import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./assets/css/DropdownPortal.css";
const DropdownPortal = ({ children, parentRef, show }) => {
    const elRef = useRef(document.createElement("div"));
    const [position, setPosition] = useState(null);

    const updatePosition = () => {
        if (parentRef.current) {
            const buttonRect = parentRef.current.getBoundingClientRect();
            const { innerWidth, innerHeight, scrollY, scrollX } = window;

            let left = buttonRect.left + scrollX;
            let top = buttonRect.bottom + scrollY;

            const dropdown = elRef.current;
            dropdown.style.visibility = "hidden"; // evita piscar

            // insere temporariamente para medir
            document.body.appendChild(dropdown);
            const dropdownRect = dropdown.getBoundingClientRect();

            if (left + dropdownRect.width > innerWidth) {
                left = innerWidth - dropdownRect.width - 8;
            }
            if (top + dropdownRect.height > innerHeight) {
                top = buttonRect.top + scrollY - dropdownRect.height;
            }
            if (left < 0) left = 8;

            setPosition({ top,  left: left -40 });
            dropdown.style.visibility = "visible";
        }
    };

    useEffect(() => {
        const el = elRef.current;
        el.style.position = "absolute";
        el.style.zIndex = 999999;
        el.style.minWidth = "200px";

        if (show) {
            if (!document.body.contains(el)) {
                document.body.appendChild(el);
            }
            updatePosition();
        } else {
            if (document.body.contains(el)) {
                document.body.removeChild(el);
                setPosition(null);
            }
        }

        const handleScroll = () => {
            if (show) updatePosition();
        };

        window.addEventListener("scroll", handleScroll, true); // true = captura scroll em containers também
        window.addEventListener("resize", updatePosition);

        return () => {
            window.removeEventListener("scroll", handleScroll, true);
            window.removeEventListener("resize", updatePosition);
            if (document.body.contains(el)) {
                document.body.removeChild(el);
            }
        };
    }, [show, parentRef]);

    useEffect(() => {
        const el = elRef.current;
        if (position) {
            el.style.top = `${position.top}px`;
            el.style.left = `${position.left}px`;
        }
    }, [position]);

    return show && position ? createPortal(children, elRef.current) : null;
};

export default DropdownPortal;
